import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function OShotHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1687">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/1Q3UVV2CdgNgJuvSnTAo2P/O-shot.jpg)'
    }} data-id="element-1688" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1689" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1690">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1691">
          <div className="mb-6" data-id="element-1692">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1693">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1694">
                Treatments
              </a>{' '}
              / Medical
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1695">
            Be HAPPY
          </span>

          <h1 className="text-[36px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-3 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1696">
            O-SHOT FOR WOMEN
          </h1>

          <p className="text-white text-2xl italic mb-6 opacity-80 font-serif" data-id="element-1697">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-1698">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1699">
              <em data-id="element-1700">
                "Ladies, let's be real—ignoring your needs isn't doing anyone
                any favors, least of all yourself,"
              </em>{' '}
              says Dr. Fiona Frie.{' '}
              <em data-id="element-1701">
                "If you want the fireworks back in the bedroom and a little
                extra sizzle in your step, the O-Shot is your go-to. Life's too
                short for dull moments, and there's no shame in giving yourself
                the boost you deserve. Confidence and pleasure? That's a
                win-win!"
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1702">
              At Be CLINICAL, we are pleased to offer the O-Shot, a proven PRP
              therapy for intimate wellness. This comprehensive approach ensures
              that women feel vibrant, empowered and confident at every age,
              inside and out.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1703">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}